import { useAppSelector } from "hooks/useStore";
import { selectModalStackShouldBlockScroll } from "store/slices/modalStack";

export const useModalStackShouldBlockScroll = () => {
  return useAppSelector(selectModalStackShouldBlockScroll);
};
